import React from 'react';
import styles from './HeaderBar.css';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';

const toolbarStyle = {
    minHeight: '55px',
};

const Header = ({ children }) => {

    return (
        <div className={styles.root}>
            <AppBar position="static">
                <Toolbar className={styles.AppBar} style={toolbarStyle}>
                    IQVIA
                    {children}
                </Toolbar>
            </AppBar>
        </div>
    );
};
export default (Header);
